@if (product) {
<div class="as-product-summary-container">
  <div class="as-product-img">
    <img
      [defaultImage]="defaultImage"
      [lazyLoad]="productImage"
      onerror="this.src='src/assets/images/default-product.svg';"
      alt="Product image"
    />
  </div>
  <mat-label class="as-height-name as-font-12">
    {{ product.description | titlecase }} </mat-label
  ><br />
  <mat-label class="as-text-align-center">
    {{ productQuantity }}
    {{ product.unit === 'GRAMMAGE' || product.unit === 'GRANEL' ? 'gr' : 'pz' }}
  </mat-label>
  <mat-label class="as-font-semibold as-text-align-center">
    {{ product.total_price | currency : '$' }}
  </mat-label>
</div>
}
